var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIngredient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0H0.5V1.48148H2V17.037C2 18.6734 3.34315 20 5 20C6.65685 20 8 18.6734 8 17.037V1.48148H9.5V0ZM7.25 7.40741H2.75V17.037C2.75 18.2643 3.75736 19.2593 5 19.2593C6.24264 19.2593 7.25 18.2643 7.25 17.037V7.40741Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0H11.5V1.48148H13V9.93647C14.0296 9.34088 15.225 9 16.5 9C17.3808 9 18.2236 9.16268 19 9.45963V1.48148H20.5V0Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 24C20.9183 24 24.5 20.4183 24.5 16C24.5 11.5817 20.9183 8 16.5 8C12.0817 8 8.5 11.5817 8.5 16C8.5 20.4183 12.0817 24 16.5 24ZM16.5 23C20.366 23 23.5 19.866 23.5 16C23.5 12.134 20.366 9 16.5 9C12.634 9 9.5 12.134 9.5 16C9.5 19.866 12.634 23 16.5 23Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11H17.5V21H15.5V11Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15H21.5V17H11.5V15Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIngredient);
export default __webpack_public_path__ + "static/media/AddIngredient.83507e6cd826f49867728adbbfdec9d4.svg";
export { ForwardRef as ReactComponent };